import { reviews as allReviews, siteConfig, type ReviewEntry } from "@/data/siteData";

export interface GoogleReview {
  name: string;
  text: string;
  rating: number;
  time: string;
  photoUri: string;
  standort?: string;
}

export interface GoogleReviewsData {
  rating: number;
  placeName: string;
  googleMapsUri: string;
  reviews: GoogleReview[];
}

function toGoogleReview(r: ReviewEntry): GoogleReview {
  return {
    name: r.name,
    text: r.text,
    rating: r.rating,
    time: "",
    photoUri: "",
    standort: r.standort,
  };
}

const RATINGS: Record<string, number> = {
  oftringen: parseFloat(siteConfig.reviewScore),
  langenthal: parseFloat((siteConfig as any).reviewScoreLangenthal || "5.0"),
};

const ALL_DATA: GoogleReviewsData = {
  rating: parseFloat(siteConfig.reviewScore),
  placeName: siteConfig.firmaName,
  googleMapsUri: "",
  reviews: allReviews.map(toGoogleReview),
};

export function useGoogleReviews(standortSlug?: string) {
  if (!standortSlug) return { data: ALL_DATA, loading: false, isLive: false };

  const filtered = allReviews
    .filter((r) => r.standort === standortSlug || r.standort === "beide")
    .map(toGoogleReview);

  return {
    data: {
      ...ALL_DATA,
      rating: RATINGS[standortSlug] ?? ALL_DATA.rating,
      reviews: filtered,
    },
    loading: false,
    isLive: false,
  };
}
